import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { FileSpreadsheet } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PendientesTab } from './justo/PendientesTab';
import { EnviosTab } from './justo/EnviosTab';
import { EquivalenciasTab } from './justo/EquivalenciasTab';
import { DestinosTab } from './justo/DestinosTab';

export default function AdminJustoPage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') || 'pendientes';
  return (
    <div className="space-y-6" data-testid="admin-justo-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
          <FileSpreadsheet className="w-7 h-7 text-green-600" /> Despachos a Justo
        </h1>
        <p className="text-slate-500 mt-1 text-sm">Transferencias de Grecia / Bodega Central a cada local en Justo</p>
      </div>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList>
          <TabsTrigger value="pendientes" data-testid="justo-tab-pendientes">Pendientes de subir</TabsTrigger>
          <TabsTrigger value="envios" data-testid="justo-tab-envios">Envíos</TabsTrigger>
          <TabsTrigger value="equivalencias" data-testid="justo-tab-equivalencias">Equivalencias Justo</TabsTrigger>
          <TabsTrigger value="destinos" data-testid="justo-tab-destinos">Locales de destino</TabsTrigger>
        </TabsList>
        <TabsContent value="pendientes"><PendientesTab /></TabsContent>
        <TabsContent value="envios"><EnviosTab /></TabsContent>
        <TabsContent value="equivalencias"><EquivalenciasTab /></TabsContent>
        <TabsContent value="destinos"><DestinosTab /></TabsContent>
      </Tabs>
    </div>
  );
}
